<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>고객 지원</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>개선해주세요.</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">개선해주세요</p>

            <div class="row align-space-between" style="width: 100%">
                <div
                    id="description"
                    class="column"
                >
                    <p style="font-weight:bold"> 고객분들의 의견을 적어주세요. 좋은 서비스를 위해 최선을 다하겠습니다.</p>
                    <ul style="padding-left:20px">
                        <li> 반복적인 내용은 관리하에 삭제될 수도 있습니다.</li>
                        <li> 해당 게시판 성격에 맞지 않는 글은 삭제될 수도 있습니다.</li>
                        <li> 네트워크 장애로 인해 내용이 저장이 안 될수도 있으니, 메모장에 작업 후 등록해주시기 바랍니다.</li>
                    </ul>
                </div>
            </div>
        </div>

        <div id="search" class="column screen-width">
            <p style="font-size: 28px; font-weight: bold">
                검색할 사항을 입력하세요
            </p>
            <search-bar :size="100" v-on:onSearch="searchComplain"></search-bar>
        </div>

        <div id="data" class="screen-width">
            <div class="row align-space-between" style="width: 100%">
                <div class="row" style="gap: 14px; margin-bottom: 16px">
                    <p
                        style="
                            font-size: 28px;
                            font-weight: bold;
                            color: #00a7e7;
                        "
                    >
                         {{ selectedMyPraise ? "내 글" : "전체"}}  
                    </p>
                    <p style="font-size: 28px; font-weight: bold">개선 요청글</p>
                </div>
                <div class="row" style="gap:16px">    
                    <button @click="findMyComplain" class="text_button" :class="{selected_button: selectedMyComplain}">
                        <p>
                            내 글 보기
                        </p>
                    </button>
                    <button
                        style="
                            width: 100px;
                            height: 40px;
                            border-radius: 12px;
                            background: #181e39;
                        "
                        @click="createComplain"
                    >
                        <p style="color: white; font-weight: bold">작성</p>
                    </button>
                </div>
            </div>
            <div id="data-list">
                <complain-list-item
                    v-for="complain in complainList" 
                    :key="complain" 
                    :title="complain.title" 
                    :category="complainCategory(complain.category)" 
                    :date="complain.createdAt" 
                    :id="String(complain.id)">

                </complain-list-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentPage"
                :totalPages="totalPages"
                v-on:update="loadPageData"
            ></custom-pagination>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import ComplainListItem from '@/components/ComplainListItem.vue';

export default {
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        CustomPagination,
        ComplainListItem
    },
    setup() {
        const store = useStore();
        const router = useRouter();
  
        const search = ref(null);
        const user_id = ref(null);
        const selectedMyComplain = ref(false);

        const complainList = computed(() => {
            return store.getters.getPCList;
        });


        const currentPage = ref(1);
        const totalPages = computed(() => {
            return Math.ceil(store.getters.getPCTotalCount / 10)
        });
        const loadPageData = (page) => {
            currentPage.value = page;
            getComplainList();
        };

        const getComplainList = () => {
            store.dispatch("getPCList", {
                userId: selectedMyComplain.value ? user_id.value : null,
                take: 10,
                search: search.value,
                page: currentPage.value,
                type: 0
            });
        }   

        const searchComplain = (word) => {
            search.value = word
            currentPage.value = 1;
            getComplainList();
        };

        const createComplain = () => {
            if (!user_id.value) {
                alert("로그인이 필요합니다.");
                return;
            }
            router.push({ path: "/add/complain" });
        };

        const moveComplainPage = (id) => {
            router.push({ path: `/customer/complain/${id}` });
        };

        const findMyComplain = () => {
            if (!user_id.value) {
                alert("로그인이 필요합니다.");
                return;
            }
            selectedMyComplain.value = !selectedMyComplain.value;
            currentPage.value = 1;
            getComplainList();
        }

        const complainCategory = (num) => {
            switch (num) {
                case 1:
                    return "제품수리"
                case 2:
                    return "전화상담"
                case 3:
                    return "설치/판매"
                case 4:
                    return "기타"
                default:
                    return ""

            }
        }
        onMounted(async () => {
            getComplainList();
            try {
                const userProfile = await store.dispatch("getUserProfile");
                user_id.value = userProfile.id;
            } catch (err) {
                console.log(err);
            }
        });

        return {
            currentPage,
            totalPages,
            loadPageData,
            complainList,
            searchComplain,
            moveComplainPage,
            createComplain,
            findMyComplain,
            selectedMyComplain,
            complainCategory
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
    flex-wrap: wrap;
}

#description {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 20px 30px;
    gap: 8px;
    flex-wrap: wrap;
}


#data {
    padding: 32px 0px;
}

#data-list {
    width: 100%;
    border-top: 1px solid black;
}

#search {
    padding: 32px 0px;
    gap: 24px;
}
.text_button {
    padding: 8px 16px;
    border: 1px solid black;
    border-radius: 20px;

}
.selected_button {
    border: 2px solid #00a7e7;
    color :  #00a7e7
}
</style>
